import React from 'react';

export const PickListIcon = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        d="M2.97461 6.08008L9.5971 9.91257L16.1746 6.10255"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.59766 16.7078V9.90527"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.04366 2.36L4.03866 4.58752C3.13116 5.09002 2.38867 6.35001 2.38867 7.38501V11.6225C2.38867 12.6575 3.13116 13.9175 4.03866 14.42L8.04366 16.6475C8.89866 17.12 10.3012 17.12 11.1562 16.6475L15.1612 14.42C16.0687 13.9175 16.8112 12.6575 16.8112 11.6225V7.38501C16.8112 6.35001 16.0687 5.09002 15.1612 4.58752L11.1562 2.36C10.2937 1.88 8.89866 1.88 8.04366 2.36Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.346 10.4302V7.68523L6.22852 3.5752"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
